var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTitleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.9375 15.6484C0.9375 17.6403 3.3104 18.6765 4.77142 17.3226L11.2512 11.3179L12.5244 10.138C12.9389 9.75394 12.9389 9.0984 12.5244 8.71433L11.2512 7.53448L4.77143 1.52968C3.31041 0.175771 0.9375 1.21195 0.9375 3.20385C0.9375 3.83934 1.20244 4.44606 1.66855 4.87801L6.57648 9.42617L1.66857 13.9743C1.20244 14.4062 0.9375 15.0129 0.9375 15.6484Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleArrow);
export default __webpack_public_path__ + "static/media/title-arrow.0e3e3bc368f23eb40f3fa158cfdd7e78.svg";
export { ForwardRef as ReactComponent };